import React, {useContext, useState} from 'react'
import UploadFile from 'components/UploadFile';
import SelectOfferFilesType from "./SelectOfferFilesType";
import DemandOffersOfferService from "services/DemandOffersOfferService";
import {useParams} from "react-router";
import OfferFilesTable from "./OfferFilesTable";
import PropTypes from "prop-types";
import {OfferMode} from "../../../../common/constants/OfferMode";
import DemandAdditionalOffersOfferService from "services/DemandAdditionalOffersOfferService";
import PurchaserOfferContext from "context/PurchaserOfferContext";
import {RoundType} from "constants/RoundType";
import SupportModeContext from "context/SupportModeContext";

function OfferFiles(
    {
        offerEdit,
        section,
        disabled,
        mode,
        roundType,
    }) {
    const params = useParams();
    const [selectedFiles, setSelectedFiles] = useState(null);
    const [configuredFiles, setConfiguredFiles] = useState(null);
    const purchaserOfferContext = useContext(PurchaserOfferContext)
    const supportMode = useContext(SupportModeContext)
    const realOnePositionMode = section.onePositionMode || offerEdit.passiveOfferForm || offerEdit.positions.length === 1
    const [portFilesWorking, setPostFilesWorking] = useState(false);

    const handleSendFiles = (uploadedFiles, config) => {
        setConfiguredFiles(null);
        if(uploadedFiles.length) {
            const tab = uploadedFiles.map((x, i) => ({
                identity: -1,
                supplierId: offerEdit.supplierId,
                positionId: realOnePositionMode ? offerEdit.positions[0].positionId : (config[`position${x.originalIndex}`] === 0 ? null : config[`position${x.originalIndex}`]),
                documentType: config[`type${x.originalIndex}`],
                containsRodo: config[`containsRodo${x.originalIndex}`],
                file: x
            }));

            switch (roundType) {
                case RoundType.BASE:
                    setPostFilesWorking(true);
                   DemandOffersOfferService.postOfferFiles(params.id, params.stageId, mode, purchaserOfferContext?.supplierId, tab).finally(()=> setPostFilesWorking(false))
                    break;
                case RoundType.ADDITIONAL_OFFERS:
                    setPostFilesWorking(true);
                    DemandAdditionalOffersOfferService.postOfferFiles(params.id, params.stageId, mode, purchaserOfferContext?.supplierId, tab).finally(()=> setPostFilesWorking(false))
                    break;
                default:
                    throw new Error("Unknown roundType: " + roundType)
            }

        }
    };

    const handleSubmitSelectDocumentTypes = (values) => {
        setConfiguredFiles({files: selectedFiles, config: values})
        setSelectedFiles(null);
    };

    return (
        <>

            {!disabled && mode === OfferMode.EDIT &&
                <UploadFile
                    onOpenConfigureFiles={(files) => setSelectedFiles(files)}
                    configuredFiles={configuredFiles}
                    onUploadPopupClosed={handleSendFiles}
                    encryptRoundId={section.encryptionEnabled ? section.roundId : undefined}
                    disabled={supportMode || purchaserOfferContext?.preview}
                    working={portFilesWorking}
                />
            }

            <OfferFilesTable
                mode={mode}
                disabled={disabled}
                offerEdit={offerEdit}
                section={section}
                roundType={roundType}
            />

            {!!selectedFiles && <SelectOfferFilesType
                items={selectedFiles}
                onCancel={() => setSelectedFiles(null)}
                onSubmit={handleSubmitSelectDocumentTypes}

                isPublished={false}
                positions={offerEdit.positions}
                onePositionMode={realOnePositionMode}
                roundType={roundType}
            />}
        </>
    )
}

OfferFiles.propTypes = {
    disabled: PropTypes.bool.isRequired,
    roundType: PropTypes.oneOf(Object.keys(RoundType)).isRequired,
    mode: PropTypes.oneOf(Object.keys(OfferMode)).isRequired,
    section: PropTypes.shape({
        onePositionMode: PropTypes.bool.isRequired,
        digitalSign: PropTypes.bool.isRequired
    }).isRequired
};

export default OfferFiles;